import { cn } from "@/lib/utils";
import { fmtDA } from "@/lib/format";

export function KpiCard({ label, value, icon: Icon, tone = "default", sub, testid, isCurrency = true }) {
  const tones = {
    default: "text-foreground",
    primary: "text-primary",
    success: "text-success",
    warning: "text-warning",
    danger: "text-destructive",
  };
  const iconBg = {
    default: "bg-muted text-muted-foreground",
    primary: "bg-accent text-accent-foreground",
    success: "bg-success/10 text-success",
    warning: "bg-warning/10 text-warning",
    danger: "bg-destructive/10 text-destructive",
  };
  return (
    <div
      data-testid={testid}
      className="group rounded-xl border bg-card p-5 hover:border-primary/40 hover:shadow-sm transition-[box-shadow,border-color,transform] hover:-translate-y-[1px]"
    >
      <div className="flex items-start justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        {Icon && (
          <span className={cn("h-9 w-9 rounded-lg flex items-center justify-center", iconBg[tone])}>
            <Icon className="h-[18px] w-[18px]" />
          </span>
        )}
      </div>
      <p className={cn("tabular text-2xl font-bold mt-3", tones[tone])}>
        {isCurrency ? fmtDA(value) : value}
      </p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>
  );
}
